import { useEffect, useState } from 'react';

export const useElementHeight = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(() => setHeight(element.offsetHeight));

    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return { ref: setElement, height };
};
